import {getDefaultDemographicInfo} from "../state/DemographicInfo";
import {SAVE_DEMOGRAPHIC_INFO} from "../action-lists";

const saveDemographicInfo = (state, action) => {
    return action.demographicInformation;
};

export default function demographicInfoReducer(state = getDefaultDemographicInfo(), action = {}) {
    const actionHandlers = {
        [SAVE_DEMOGRAPHIC_INFO]: saveDemographicInfo
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}